import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { PrimaryButton } from "../../Shared/Buttons";
import CreateHost from "cross-domain-storage/host";
// import ModalImage from "../../Assets/ModalImage.png";
import { CheckCircleOutline } from "@material-ui/icons";
import { Auth } from "aws-amplify";

const SuccesModal = ({
  classes,
  handleSaveModalClose,
  restName,
  email,
  apikey,
}) => {
  let rName = restName && restName.replace(/ /g, "-");
  const [IdToken, setIdToken] = useState("");
  const [userId, setUserId] = useState("");
  useEffect(() => {
    Auth.currentSession()
      .then((data) => {
        if (data) {
          // data.accessToken.payload.username
          setIdToken(data.getIdToken().getJwtToken());
          // history.push(inMemRoute);
          setUserId(data.accessToken.payload.username);
        }
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const guest = window.location.host.includes("local")
    ? "http://localhost:3000"
    : process.env.REACT_APP_CORPORATE_PATH;

  const RestaurantDashboardHandler = () => {
    handleSaveModalClose();
    const storageHost = CreateHost([
      {
        origin: `${guest}`,
        allowedMethods: ["get", "set", "remove"],
      },
    ]);

    localStorage.setItem("restName", restName);
    localStorage.setItem("email", email);
    localStorage.setItem("apikey", apikey);
    localStorage.setItem("mode", "superadmin");
    localStorage.setItem("idToken", IdToken);
    let clientId = process.env.REACT_APP_USER_POOL_CLIENT;
    let arrSharedValue = [
      // `${localStorage.getItem(`restId`)}`,
      `${localStorage.getItem(`apikey`)}`,
      `${localStorage.getItem(`restName`)}`,
      `${localStorage.getItem(`mode`)}`,
      `${localStorage.getItem(`amplify-signin-with-hostedUI`)}`,
      `${localStorage.getItem(
        `CognitoIdentityServiceProvider.${clientId}.${userId}.idToken`
      )}`,
      `${localStorage.getItem(
        `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`
      )}`,

      `${localStorage.getItem(
        `CognitoIdentityServiceProvider.${clientId}.${userId}.clockDrift`
      )}`,
      `${localStorage.getItem(
        `CognitoIdentityServiceProvider.${clientId}.${userId}.accessToken`
      )}`,
      `${localStorage.getItem(
        `CognitoIdentityServiceProvider.${clientId}.${userId}.userData`
      )}`,
      `${localStorage.getItem(
        `CognitoIdentityServiceProvider.${clientId}.${userId}.refreshToken`
      )}`,
    ];
    localStorage.setItem("sharedStorage", JSON.stringify(arrSharedValue));
    window.open(`${guest}/login/${userId}/${rName}`);
  };
  return (
    <>
      <Grid container direction="row">
        <Grid item xs={12} className={classes.mt20}>
          <Typography variant="h4" align="center" color="primary">
            Restaurant Created
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item xs={3} />
        <Grid item xs={6} className={classes.mt40}>
          <CheckCircleOutline color="primary" className={classes.iconStyles} />
        </Grid>
        <Grid item xs={3} />
      </Grid>
      <Grid container direction="row" spacing={1} className={classes.mt40}>
        <Grid item xs={12} sm={8}>
          <PrimaryButton
            type="success"
            fullWidth={true}
            handleClick={RestaurantDashboardHandler}
            testId={`access_rest_btn`}
          >
            ACCESS RESTAURANT DASHBOARD
          </PrimaryButton>
        </Grid>
        <Grid item xs={12} sm={4}>
          <PrimaryButton
            testId={`close_modal_btn`}
            type="faded"
            fullWidth={true}
            handleClick={handleSaveModalClose}
          >
            close
          </PrimaryButton>
        </Grid>
      </Grid>
    </>
  );
};

export default SuccesModal;
